// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import {
  PharmacyGroupDrugActions,
  PharmacyGroupDrugActionTypes,
} from '../_actions/pharmacy-group-drug.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { PharmacyGroupDrug } from '../_models/pharmacy-group-drug.model';

// tslint:disable-next-line:no-empty-interface
export interface PharmacyGroupDrugsState extends EntityState<PharmacyGroupDrug> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPharmacyGroupDrugId: number;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<PharmacyGroupDrug> = createEntityAdapter<PharmacyGroupDrug>();

export const initialPharmacyGroupDrugsState: PharmacyGroupDrugsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedPharmacyGroupDrugId: undefined,
  showInitWaitingMessage: true,
});

export function pharmacyGroupDrugsReducer(
  state = initialPharmacyGroupDrugsState,
  action: PharmacyGroupDrugActions,
): PharmacyGroupDrugsState {
  switch (action.type) {
    case PharmacyGroupDrugActionTypes.PharmacyGroupDrugsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPharmacyGroupDrugId: undefined,
      };
    case PharmacyGroupDrugActionTypes.PharmacyGroupDrugsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case PharmacyGroupDrugActionTypes.PharmacyGroupDrugUpdated:
      return adapter.updateOne(action.payload.partialPharmacyGroupDrug, state);
    case PharmacyGroupDrugActionTypes.PharmacyGroupDrugStoreUpdated:
      return adapter.updateOne(action.payload.pharmacyGroupDrug, state);
    case PharmacyGroupDrugActionTypes.PharmacyGroupDrugDeleted:
      return adapter.removeOne(action.payload.id, state);
    case PharmacyGroupDrugActionTypes.PharmacyGroupDrugsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case PharmacyGroupDrugActionTypes.PharmacyGroupDrugsPageLoaded: {
      return adapter.addMany(action.payload.pharmacyGroupDrugs, {
        ...initialPharmacyGroupDrugsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case PharmacyGroupDrugActionTypes.ThrowPharmacyGroupDrugError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PharmacyGroupDrugActionTypes.FirePharmacyGroupDrugSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    case PharmacyGroupDrugActionTypes.ClearPharmacyGroupDrugState: {
      return initialPharmacyGroupDrugsState;
    }
    default:
      return state;
  }
}

export const getPharmacyGroupDrugState =
  createFeatureSelector<PharmacyGroupDrugsState>('pharmacyGroupDrugs');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
